import React from 'react';
import PropTypes from 'prop-types';

import AsyncStatus from 'enums/AsyncStatus';

import 'css/ui/Status.css';




class Status extends React.Component {

	render() {
		const { asyncStatus, pendingMessage, errorMessage, animationDelay } = this.props;

		let content;

		if (asyncStatus === AsyncStatus.PENDING) {
			content = pendingMessage;
		}
		else if (asyncStatus === AsyncStatus.FAILURE) {
			content = errorMessage;
		}
		else {
			return null;
		}

		return (
			<div className="status fade-slide-up" style={{ animationDelay: `${animationDelay}s` }}>
				{content}
			</div>
		);
	}
}

export default Status;


Status.defaultProps = {
	pendingMessage: 'Loading',
	errorMessage: 'Failed to load data',
	animationDelay: 0
};

Status.propTypes = {
	asyncStatus: PropTypes.oneOf(Object.values(AsyncStatus)),
	pendingMessage: PropTypes.string,
	errorMessage: PropTypes.string,
	animationDelay: PropTypes.number
};



// WEBPACK FOOTER //
// ./src/ui/Status.jsx